import React from 'react'
import { makeStyles, useMediaQuery } from '@material-ui/core'
import {
  AppGalleryIcon,
  AppGalleryMobileIcon,
  AppStoreIcon,
  AppStoreMobileIcon,
  PlayStoreIcon,
  PlayStoreMobileIcon,
} from '../SVGIcons'

const getDownloadIcon = (link, isDesktop) => {
  if (link.includes('apple.com'))
    return isDesktop ? <AppStoreIcon /> : <AppStoreMobileIcon />
  if (link.includes('google.com'))
    return isDesktop ? <PlayStoreIcon /> : <PlayStoreMobileIcon />
  if (link.includes('huawei.com'))
    return isDesktop ? <AppGalleryIcon /> : <AppGalleryMobileIcon />
  return null
}

const AppDownloadLink = ({ link }) => {
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('md'))

  const styles = useStyles()
  return (
    <a
      onClick={() => {
        if (
          typeof window !== 'undefined' &&
          // eslint-disable-next-line no-undef
          typeof window.gtag === 'function'
        ) {
          // eslint-disable-next-line no-undef
          window.gtag('event', 'download_app_clicked', { url: link })
        }
      }}
      target="_blank"
      rel="noopener noreferrer"
      href={link}
      className={styles.link}
    >
      {getDownloadIcon(link, isDesktop)}
    </a>
  )
}

const useStyles = makeStyles((theme) => ({
  link: {
    '&>svg': {
      width: '100%',
    },
  },
}))

export default AppDownloadLink
